<template>
  <div id="ag-canvas" class="videoScreen onviewerScreen onviewerScreenview ">
    <transition name="fade">
      <div v-if="reportStream" class="handleReportStream">
        <ul>
          <li
            v-for="(item, index) in contentReportList"
            :key="index"
            :class="{ active: active_el === index }"
            @click="reportBroadCasterStreaming(index, contentReportList[index])"
          >
            {{ item.displayNameHi }}
          </li>
        </ul>
      </div>
    </transition>
    <div class="profile_state">
      <div class="profile_col">
        <div class="profile-title">
          <span
            class="ag-btn videoExitBtn"
            title="Exit"
            @click.prevent="handleExit"
          >
            <img src="../assets/images/cross.png" class="viewerVideoClose" />
          </span>
          <div class="profile-name">
            <span class="profile-img">
              <img v-if="userImage" :src="userImage" />
              <img v-else src="../assets/images/avatar1.png" />
            </span>
            <div class="userCountValue">
              <span class="userTitle" v-if="firstName">{{
                replcePhoneWithAsterik(firstName)
              }}</span>
              <span class="userTitle" v-else>{{ $t('goLive') }}</span>
              <!-- <span class="followerCount"
                ><i class="material-icons">supervisor_account</i> 200</span
              > -->
            </div>

            <span
              v-if="!promotedUser && !isFollower"
              style="cursor: pointer"
              class="followtext"
              @click="followUser"
            >
              <i class="fa fa-user-plus" aria-hidden="true"></i>
              <!-- {{ $t('follow') }} -->
            </span>
            <span v-if="isFollower" class="followtext following-text">
              <i class="fa fa-check" aria-hidden="true"></i>
              <!-- {{ $t('following') }} -->
            </span>
          </div>
          <!-- <span class="locationBar">
            <i class="fa fa-map-marker-alt"></i>
            {{ userLocation }}
          </span> -->
          <div class="report_section">
            <span class="counter">
              <span class="liveUserCount">
                <i class="far fa-eye"></i>
                {{ liveUserCount }}
              </span>
            </span>
          </div>
        </div>
      </div>

      <div v-if="readyState" class="ag-btn-group active RgtColState">
        <div class="activityButton">
          <span
            class="broadCallbtn"
            v-if="audioCallBtn"
            @click.prevent="callToBroadcaster()"
          >
            <i class="fa fa-phone" aria-hidden="true"></i>
          </span>

          <div v-if="showDnd" class="broadCalldnd">
            <span class="callDnd">
              <i class="material-icons">phone_locked</i>
            </span>
            <span class="callTitle">{{ $t('CallDND') }}</span>
          </div>

          <div v-if="showBusy" class="broadCallBusy">
            <span class="callBusy">
              <i class="material-icons">phone_callback</i>
            </span>
            <span class="callTitle">{{ $t('CallBusy') }}</span>
          </div>

          <div class="callState" v-if="showDisconnectCall">
            <span class="callCancle" @click="changeRoleAgain()">
              <i class="fa fa-phone cancelp" aria-hidden="true"></i>
            </span>
          </div>

          <div
            v-if="isAdminUser"
            @click="handleBlockUser"
            class="blockUserbanned"
          >
            <span class="banIocn">
              <i class="fa fa-ban" title="banned"></i>
            </span>
          </div>

          <div v-if="!promotedUser" class="reportStream">
            <i class="material-icons " @click="reportStream = !reportStream"
              >more_vert</i
            >
          </div>
        </div>
      </div>
    </div>

    <div
      v-touch:tap="viewer_side_special_effect_emit"
      class="blank-screenbox"
      :class="{ 'blank-screenbox-promotion': promotedUserLive }"
    >
      &nbsp;
    </div>
    <!-- <div v-if="pubishState" class="choose_category_option">
            <div class="category_item">
            <div class="selected_category">
              <div class="change_category_ico">
                <span><i class="fa fa-caret-down"></i> Change Category</span>
                </div>
              <i class="fa fa-caret-down"></i> Money91</div>
            <ul>
              <li><span>Money91 </span><span><img src="../assets/images/catIconM91.png"></span></li>
              <li><span>Questionary </span><span><img src="../assets/images/catIconQa.png"></span></li>
              <li><span>Live TV </span><span><img src="../assets/images/catIconTv.png"></span></li>
              <li><span>Shopping </span><span><img src="../assets/images/catIconSh.png"></span></li>
            </ul>
            </div>
    </div> -->
    <loading :active.sync="isLoading"></loading>
    <!-- <div class="screen-panel" v-if="isLoading">
      <div class="logo-screen">
        <span class="logo">
          <img src="../assets/images/live_loader.gif">
        </span>
      </div>
    </div> -->
    <div class="event_day">
      <!-- <img
        v-if="event_active"
        src="../assets/images/independence_event-icon.png"
        class="eventImg"
        @click="handleLeaderBoardRedirection"
      />
 
      <img
        src="../assets/images/leaderboard-logo.png"
        class="eventImg"
        @click="handleLeaderBoardRedirection"
      /> -->
      <!-- <slidingTab @weekMonthHandle="handleLeaderBoardRedirection" /> -->
    </div>
    <div v-if="pubishState" class="chatlog-box">
      <!-- <p
        id="questionareBtn"
        v-if="
          this.$store.getters.selected === 'questionary' ||
            this.$route.query.category === 'qna'
        "
        class="questionare_icon"
        @click="openQuestinareModal()"
      >
        <img src="../assets/images/Q-A_icon_broadcaster.png" />
      </p> -->
      <!-- <span
        id="shoppingBtn"
        class="shopping_icon"
        @click="viewerProductModel()"
      >
        <img v-if="viewerProductImage" :src="viewerProductImage" />
      </span> -->
      <!-- v-on:scroll="scrollFunction" -->
      <ul id="chatRoomList" v-on:scroll="scrollFunction">
        <li v-for="item in allMessages" :class="{ 'joined-room': item.joined }">
          <div class="chat-list">
            <div class="user-infotext">
              <span class="user-bage">
                <!-- <img v-if="item.image === 'null'"  src="../assets/images/avatar1.png"/> -->
                <img
                  v-if="item.image"
                  :src="
                    item.image === 'avatar1' || item.image === null
                      ? require('../assets/images/avatar1.png')
                      : item.image
                  "
                />
              </span>
              <span class="viewerName">
                {{ replcePhoneWithAsterik(item.msg_from) }} :
                <span class="viewerMsg">{{ item.msg }}</span>
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div v-if="pubishState && !promotedUser" class="chat-bottom">
      <div class="detailChatBox" :class="{ hide: isChatBox }">
        <span class="lets_chat" @click="toggleChat()" id="toggle-chat"
          ><i class="material-icons">chat</i>
          <span class="chat_text">{{ $t('plzchat') }}</span></span
        >
        <!-- <span
          class="broadCallbtn"
          v-if="audioCallBtn"
          @click.prevent="callToBroadcaster()"
        >
          <i class="fa fa-phone" aria-hidden="true"></i>
        </span> -->

        <!-- <div v-if="showDnd" class="broadCalldnd">
          <span class="callDnd">
            <i class="material-icons">phone_locked</i>
          </span>
          <span class="callTitle">Call DND</span>
        </div> -->

        <!-- <div v-if="showBusy" class="broadCallBusy">
          <span class="callBusy">
            <i class="material-icons">phone_callback</i>
          </span>
          <span class="callTitle">Call Busy</span>
        </div> -->

        <span id="myBtn" class="gift_icon" @click="openModal()">
          <img src="../assets/images/gift.png" />
        </span>
      </div>
      <div class="itemBox" :class="{ up_row: isChatBox }">
        <!-- <span class="lets_chat">Close X</span> -->
        <!-- <div class="itemCard_Panel">
          <div class="itemCards">
            <img v-if="viewerProductImage" :src="viewerProductImage" />
            <span class="buyers_count">1160 लोगो ने ये सौदा ख़रीदा है</span>
            <span class="your_amount">आपकी कीमत</span>
            <span class="item_amount">
              ₹ 140.0
              <span class="actual_amount">240.0</span>
            </span>
            <div class="golive_btn">
              <button type="button" class="btn_red">अभी खरीदें</button>
            </div>
          </div>
        </div> -->
        <ViewerProductList
          :channel="channel"
          :roomOwnerXAuthID="roomOwnerXAuthID"
          :viewerProductList="viewerProductList"
        />
      </div>
    </div>

    <div v-if="promotedUser" class="sharebutton">
      <button class="btn btn-danger" @click="openPromotedURl">
        <i class="fas fa-external-link-alt"></i> {{ $t('Openlink') }}
      </button>
    </div>

    <div class="heart-wrapper">
      <div id="heartRef" ref="heartRef" class="heartWrap-content"></div>
    </div>
    <!-- The giftModal -->
    <div id="Chat-modal" class="wallet modal">
      <div class="modal-content chatPart chat-contentbox chat-bottom">
        <div class="typeComment" v-if="!isChat">
          <input
            id="msg-chatbox"
            v-model="textMessage"
            type="text"
            class="input-chat"
            :placeholder="$t('startchat')"
            @blur="reSizeCommentBox"
            @keyup.enter="addMessage"
          />
          <span class="send-chat" @click="addMessage()">
            <i class="material-icons fasend">send</i>
          </span>
        </div>
      </div>
    </div>

    <div id="giftModal" class="wallet modal">
      <!-- Modal content -->

      <div class="modal-content tipPart tip-contentbox">
        <button
          id="myBtn"
          type="button"
          class="close1"
          @click.prevent="closeModal()"
        >
          <span>&times;</span>
        </button>
        <div class="modal-body gift-iconbox">
          <!-- <p class="hl"></p> -->
          <p>{{ $t('ifuliketalent') }}</p>
          <ul>
            <h2 class="textMcash">MPoint {{ $t('give') }}</h2>
            <li>
              <div>
                <span v-for="(gift, index) in McashGifts" :key="index">
                  <img
                    v-if="gift.imageURL"
                    :src="gift.imageURL"
                    :class="{
                      active: selectedId && McashGifts[index].id === selectedId
                    }"
                    @click="updateSelectedGift(index, gift.id)"
                  />
                  <img v-else src="../assets/images/avatar1.png" />
                </span>
              </div>
            </li>
            <h2 class="textMcash">
              &#x20B9; {{ $t('Wallet') }} {{ $t('give') }}
            </h2>
            <li>
              <div>
                <span v-for="(gift, index) in walletGifts" :key="index">
                  <img
                    v-if="gift.imageURL"
                    :src="gift.imageURL"
                    :class="{
                      active: selectedId && walletGifts[index].id === selectedId
                    }"
                    @click="updateSelectedGift(index, gift.id)"
                  />
                  <img v-else src="../assets/images/avatar1.png" />
                </span>
              </div>
            </li>
            <button
              type="button"
              class="btn btn-default rewardBtn"
              @click="sendGifts()"
            >
              {{ $t('givereward') }}
            </button>
          </ul>
        </div>
      </div>
    </div>

    <!-- . viewer product list -->
    <!-- <div
      id="liveproduct-modelbox"
      class="wallet modal"
      :class="{ 'active-prdt': activePrdt }"
    >
      <span class="close-prdt" @click="closeModal()">
        <img src="../assets/images/cross1.png" />
      </span>
      <ViewerProductList
        :channel="channel"
        :roomOwnerXAuthID="roomOwnerXAuthID"
        :viewerProductList="viewerProductList"
      />
    </div> -->

    <!-- The quetionareModal -->

    <div id="quetionareModal" class="wallet modal">
      <div class="modal-content questionPart question-contentbox">
        <div v-if="!showQuestionGift" class="writeQuestion">
          <button
            id="questionareBtn"
            type="button"
            class="close1"
            @click.prevent="closeModal()"
          >
            <img src="../assets/images/cross.png" />
          </button>
          <p class="heading">{{ $t('writequestion') }}</p>

          <p class="quetionNotice">{{ $t('whattogiveforquestion') }}</p>
          <div class="questionPreviewList">
            <div class="title">{{ $t('questionasked') }}</div>
            <div class="askedQuestionList">
              <span v-for="(data, key) in viewerQNAquestionlist"
                >{{ key + 1 }}: {{ data }}</span
              >
            </div>
          </div>
          <p class="writequestionBox">
            <input
              type="text"
              id="QNAinputBox"
              :placeholder="$t('writequestion')"
              @input="handleChangeQNA($event)"
              @keyup.enter="showQuestionPayBlock"
            />
          </p>
          <button
            type="button"
            class="btn btn-default rewardBtn"
            @click="showQuestionPayBlock()"
          >
            {{ $t('continue') }}
          </button>
        </div>
        <div v-if="showQuestionGift" class="modal-body question-iconbox">
          <button
            id="questionareBtn"
            type="button"
            class="close1"
            @click.prevent="closeModal()"
          >
            <img src="../assets/images/cross.png" />
          </button>
          <div class="writeQuestion">
            <p class="heading">{{ $t('payforques') }}</p>
            <div class="questionPreview">
              <p>
                {{ $t('yourques') }}:-
                <span>{{ QNAquestion }}</span>
              </p>
              <p class="quetionNotice">{{ $t('whattogiveforquestion') }}</p>
            </div>
          </div>
          <ul>
            <h2 class="textMcash">MPoint {{ $t('give') }}</h2>
            <li>
              <div>
                <span v-for="(gift, index) in McashGifts" :key="index">
                  <img
                    v-if="gift.imageURL"
                    :src="gift.imageURL"
                    :class="{
                      active: index === selectedIdMCash
                    }"
                    @click="updateSelectedGiftMCash(index, gift.id)"
                  />
                  <img v-else src="../assets/images/avatar1.png" />
                </span>
              </div>
            </li>
            <!-- <h2 class="textMcash">&#x20B9; Wallet {{ $t('give') }}</h2> -->
            <li>
              <div>
                <span v-for="(gift, index) in walletGifts" :key="index">
                  <img
                    v-if="gift.imageURL"
                    :src="gift.imageURL"
                    :class="{
                      activeWallet: index === selectedIdWallet
                    }"
                    @click="updateSelectedGiftWallet(index, gift.id)"
                  />
                  <img v-else src="../assets/images/avatar1.png" />
                </span>
              </div>
            </li>
            <div class="questionButton">
              <button
                type="button"
                class="btn btn-default backBtn"
                @click="returnOnQuestion()"
              >
                <img src="../assets/images/back_arrow.png" />
                &nbsp;
                {{ $t('back') }}
              </button>
              <button
                type="button"
                class="btn btn-default rewardBtn"
                :disabled="
                  QNAmcashValue == '' && QNAwalletvalue == '' ? true : false
                "
                @click="handleQNAquestion"
              >
                {{ $t('topay') }}
              </button>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <!-- <div id="shoppingModal" class="wallet modal">
      <ul>
        <li class="order-content">
          <div class="order-cardbox">
            <div class="prdt_detail">
              <div class="img-box">
                <img
                  src="https://d3ojr524tgla9b.cloudfront.net/130cd03c-7725-4962-866c-0c8c42148c1f_large.png"
                />
              </div>
              <div class="right-dtl">
                <h3>Dinesmart Elora Serving Medium Melamine Tray</h3>
                <div class="text_style">
                  <p class="text-seller">डिस्काउंट मूल्य</p>
                  <p class="text-discountprice">₹ 99.0</p>
                </div>
                <div class="text_style">
                  <p class="text-seller">आपका कमिशन</p>
                  <p class="text-commisionprice">₹ 4.95</p>
                </div>
              </div>
            </div>
            <div class="dealstatus">
              <button type="button" class="btn-archive">
                <input type="text" id="myInput" />
                <span>कॉपी</span>
              </button>
              <button type="button" class="btn-complete">शेयर करें</button>
            </div>
          </div>
        </li>
      </ul>
    </div>-->

    <!-- <LeaderBoardTimer
      :intervalTimer="intervalTimer"
      :timerLeft="timerLeft"
      v-if="openBoard && showTimer"
    /> -->

    <LeaderBoard15aug
      v-if="openBoard"
      :weekMonthLeaderboard="weekMonthLeaderboard"
      :XAuthID="roomOwnerXAuthID"
      :leaderBoardViewportList="leaderBoardViewportList"
    />

    <div
      class="viewCalloverlay"
      v-if="showDisconnectCall"
      v-bind:style="{ display: viewCalloverlayCalling }"
    >
      <div class="viewCallSceenModel viewerScreencall">
        <div class="callFromtext">
          <div class="callTitle">Calling..</div>
        </div>
        <div class="callState viewerCallcanel">
          <span class="callCancle" @click="declineCalling()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>

    <div
      class="viewCalloverlay"
      v-if="pubishState"
      v-bind:style="{ display: viewCalloverlay }"
    >
      <div class="viewCallSceenModel viewerScreencall">
        <div class="callFromtext">
          <div class="callTitle">{{ $t('CallingggYou') }}</div>
          <div class="forText">{{ $t('For') }}</div>

          <!-- <input v-model.number="callingCash" type="number" /> -->

          <div class="callingforcash">
            <div class="tiptextCol">
              <mcash-value
                @macashValue="callingCashHandle"
                :callingCash="callingCash"
              />
              <div class="mcashTitle">MPoint</div>
            </div>
          </div>
        </div>

        <div class="callState">
          <span class="callCancle" @click="notCalling()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
          <span class="callReceivd" @click="confirmCalling()">
            <i class="fa fa-check" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { merge } from 'lodash'
import * as Cookies from 'js-cookie'
import Vue2TouchEvents from 'vue2-touch-events'
import { adminXAuthIds } from '../utils/constant'
import Vue from 'vue'
import LoveComponent from './loveComponent.vue'
import Loading from 'vue-loading-overlay'
import gaali from '../utils/gaali'
import {
  replcePhoneWithAsterik,
  initAgora,
  parsoDi,
  aajDi,
  Timer
} from '../utils/helper'
import ViewerProductList from './ViewerProductList'
import { clearInterval } from 'timers'
import { BASE_API_URL, LOCAL_URL } from '../utils/constant'
// import ShoppingViewerScreen from '../views/shoppingViewerScreen'
import McashValue from '../components/McashValue'
import LeaderBoardTimer from './LeaderBoardTimer'
import LeaderBoard15aug from './leaderBoard15aug'
import slidingTab from './slidingTab'

Vue.use(Vue2TouchEvents, {
  touchClass: '',
  tapTolerance: 10,
  swipeTolerance: 30,
  longTapTimeInterval: 400
})
export default {
  name: 'AgoraViewer',
  components: {
    Loading,
    ViewerProductList,
    McashValue,
    LeaderBoardTimer,
    LeaderBoard15aug,
    slidingTab
  },
  props: [
    'transcode',
    'attendeeMode',
    'videoProfile',
    'channel',
    'baseMode',
    'appId',
    'uid',
    'source'
  ],
  data() {
    return {
      isChatBox: false,
      leaderBoardViewportList: [],
      isChat: false,
      interval: null,
      userRole: 'audience',
      audioCall: false,
      bubbleColors: ['red', 'blue', 'sky_blue', 'yellow', 'purple'],
      showQuestionGift: false,
      contentID: '',
      viewerProductImage: null,
      viewerProductList: null,
      bubbleImages: [
        'bubble-img',
        'bubble-img1',
        'bubble-img2',
        'bubble-img3',
        'bubble-img4',
        'bubble-img5',
        'bubble-img6'
      ],
      active_el: '',
      reportStream: false,
      isLoading: false,
      userLocation: '',
      items: [
        require('../assets/images/purple_heart.png'),
        require('../assets/images/yellow_heart.png'),
        require('../assets/images/red_heart.png'),
        require('../assets/images/sky_blue_heart.png'),
        require('../assets/images/blue_heart.png')
      ],
      isActive: true,
      roomOwnerMobileNo: null,
      count: 0,
      sound: '',
      isAdminUser: false,
      selectedId: 0,
      selectedIdMCash: 0,
      selectedIdWallet: '',
      selectedType: 0,
      selectedValue: 0,
      freeGifts: [],
      McashGifts: [],
      walletGifts: [],
      giftImage: '',
      client: {},
      localStream: {},
      shareClient: {},
      shareStream: {},
      displayMode: 'pip',
      streamList: [],
      roomOwnerXAuthID: null,
      readyState: false,
      pubishState: false,
      isFollower: false,
      currentRoomId: '',
      textMessage: '',
      allMessages: [],
      xAuthId: Cookies.get('X-Auth-Id') || null,
      xAuthToken: Cookies.get('X-Auth-Token') || null,
      firstName: '',
      lastName: '',
      userImage: '',
      touchEventClick: true,
      liveUserCount: 0,
      promotedUser: false,
      contentReportList: [],
      abusive: gaali,
      promotedUserLive: false,
      promotedurl: null,
      activePrdt: false,
      QNAquestion: '',
      QNAmcashValue: '2',
      QNAwalletvalue: '0',
      viewerQNAquestionlist: [],
      isValueSelectedMCash: true,
      isValueSelectedWallet: true,
      audioCallBtn: false,
      showDisconnectCall: false,
      showBusy: false,
      showDnd: false,
      viewCalloverlay: 'none',
      viewCalloverlayCalling: 'none',
      callingCash: 1,
      callStates: 'decline',
      initiatedCallXauthId: null,
      callerStream: false,
      callerStreamData: {},
      event_active: true,
      showTimer: false,
      intervalTimer: null,
      timerLeft: {},
      openBoard: false
    }
  },
  watch: {
    viewerProductList: function(newVal, oldVal) {
      console.log('--===-=newVal==', newVal)
      console.log('--===-==oldVal=', oldVal)
    }
  },
  methods: {
    reSizeCommentBox() {
      // alert('tyugyhj')
      setTimeout(() => {
        this.isChatBox = false
        $('#Chat-modal').modal('hide')
      }, 200)
    },
    replcePhoneWithAsterik,
    handleZero() {
      console.log('====emitiing')
    },
    callingCashHandle(data) {
      this.callingCash = data
    },
    handleDateCounter() {
      this.timerLeft = Timer('14 August,2019 24:00')
      console.log('=====', this.timerLeft)
      return this.timerLeft
    },
    handleLeaderBoardRedirection(data) {
      console.log('=--=-data=-=-data=-=-=', data)
      this.openBoard = true
      document.querySelector('body').classList.add('leadBodypop')
      this.weekMonthLeaderboard = data
      this.$http
        .get(
          `${LOCAL_URL}/weekly_and_monthly_leader_board?page_no=1&category=${data}`
        )
        .then(
          function(data) {
            if (data.body) {
              // this.userData = data.body.data.data
              this.leaderBoardViewportList = data.body.data.data
            }
          },
          response => {}
        )
      // console.log('====', window._intervalTimerToogle)
      // if (window._intervalTimerToogle === false) {
      //   document.querySelector('body').classList.add('leadBodypop')
      //   window.clearInterval(window._intervalTimer)
      //   this.showTimer = false
      // } else {
      //   this.showTimer = true
      //   document.querySelector('body').classList.add('popbody')
      //   window._intervalTimer = setInterval(this.handleDateCounter, 1000)
      //   window._intervalTimerToogle = true
      // }
    },

    loadViwerStreaming() {
      let $ = this
      $.client = AgoraRTC.createClient({ mode: $.transcode })
      $.client.init($.appId, () => {
        $.subscribeStreamEvents()
        $.client.join($.appId, $.channel, $.uid, uid => {
          console.log('=-=-=this=--=', this)
          $.localStream = this.streamInit(uid, $.attendeeMode, $.videoProfile)
          $.localStream.init(
            () => {
              if ($.attendeeMode !== 'audience') {
                $.addStream($.localStream, true)
                $.client.publish($.localStream, err => {
                  console.log('Publish local stream error: ' + err)
                })
              } else {
                $.client.setClientRole(
                  'audience',
                  { monu: 'monu' },
                  function() {
                    console.log('setHost success')
                  },
                  function(e) {
                    console.log('setHost failed', e)
                  }
                )
              }

              $.readyState = true
              this.pubishState = true
            },
            err => {
              console.log('getUserMedia failed', err)
              $.readyState = true
              this.pubishState = true
            }
          )
        })
      })
    },
    handleExitShopping() {
      this.handleExit()
    },
    scrollFunction() {
      // var a = document.getElementById('chatRoomList')
      // var b = a.scrollTop + a.offsetHeight
    },

    changeLocale(locale) {
      let lang = this.$cookie.get('lang')
      let inLang = (...arg) => arg.includes(lang)
      document
        .querySelector('body')
        .classList.add(
          `lang-${
            inLang('bn', 'gu')
              ? 'lang-multi'
              : inLang('pa', 'kn')
              ? 'lang-pa'
              : lang
          }`
        )
      this.$i18n.locale = this.$cookie.get('lang') || 'hi'
    },

    reportBroadCasterStreaming(el, data) {
      console.log('==el==', el, data)
      this.active_el = el
      let headers = {
        'X-Auth-Id': this.xAuthId,
        'X-Auth-Token': 'da85e2fb-295d-43d4-b7a6-85a5d3c235f9',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
      let obj = {
        contentId: this.contentID,
        reportingReason: data.enumName
      }
      this.$http
        .post(
          'https://be.payboard.in/PayBoard/rest/channels/report-abuse',
          obj,
          {
            headers
          }
        )
        .then(function(data) {
          this.reportStream = false
          this.$toast.top(this.$t('reportPost'))
        })
    },

    handleChangeQNA(event) {
      this.QNAquestion = event.target.value
    },

    handleQNAquestion() {
      if (this.QNAquestion != '') {
        if (
          this.QNAquestion &&
          this.QNAwalletvalue == '' &&
          this.QNAmcashValue == ''
        ) {
          this.$toast.top(this.$t('noWallet'))
        } else {
          let naeHo = {
            msg: this.QNAquestion,
            x_auth_id: this.xAuthId,
            room_id: this.channel,
            mcash: this.QNAmcashValue,
            wallet: this.QNAwalletvalue
          }
          let belhar = parsoDi(naeHo)
          this.$socket.emit('ask_question', { cipher_text: belhar })
        }
        this.closeModal()
      } else {
        this.$toast.top(this.$t('Kindlyaskquestion'))
      }
      this.QNAquestion = ''
    },
    sendQuestionGifts() {
      $('#quetionareModal').modal('hide')
    },
    returnOnQuestion() {
      this.showQuestionGift = false
    },
    showQuestionPayBlock() {
      this.showQuestionGift = true
    },
    handleReportStream() {
      this.reportStream = true
    },
    // special emit socket ######################### //
    viewer_side_special_effect_emit() {
      this.$socket.emit('special_effect', {
        room_id: this.channel,
        broadcaster_mobile_no: this.roomOwnerMobileNo
      })
      this.playSound(`${require('../assets/soundClip/heartSound2.mp3')}`)
      return
    },
    playSound(sound) {
      if (sound) {
        let audio = new Audio(sound)
        audio.play()
      }
    },
    viewer_side_heart_render(color) {
      let newcount = ++this.count
      var r = Math.round(Math.random() * 6)
      var img = require(`../assets/images/${color}_heart.png`)
      var ComponentClass = Vue.extend(LoveComponent)
      var instance = new ComponentClass({
        propsData: {
          type: `fa fa-heart ${this.bubbleImages[r]}`,
          src: img,
          id: `faID${newcount}`
        }
      })
      instance.$mount()
      this.$refs.heartRef.appendChild(instance.$el)
      setTimeout(function() {
        document.getElementById(`faID${newcount}`).remove()
      }, 2000)
    },

    updateSelectedGift(index, id) {
      if (this.freeGifts.map(fg => fg.id).includes(id)) {
        this.$data.selectedId = this.freeGifts[index].id
        this.$data.selectedType = this.freeGifts[index].giftType
        this.$data.selectedValue = this.freeGifts[index].value
      }
      if (this.McashGifts.map(mg => mg.id).includes(id)) {
        this.$data.selectedId = this.McashGifts[index].id
        this.$data.selectedType = this.McashGifts[index].giftType
        this.$data.selectedValue = this.McashGifts[index].value
      }
      if (this.walletGifts.map(mg => mg.id).includes(id)) {
        this.$data.selectedId = this.walletGifts[index].id
        this.$data.selectedType = this.walletGifts[index].giftType
        this.$data.selectedValue = this.walletGifts[index].value
      }
      this.updateSelectedGift == true
    },
    updateSelectedGiftMCash(index, id) {
      this.QNAwalletvalue = 0
      this.selectedIdWallet = ''
      if (this.selectedIdMCash === index) {
        this.isValueSelectedMCash = false
        this.selectedIdMCash = ''
      } else {
        this.isValueSelectedMCash = true
        this.selectedIdMCash = index
      }
      if (this.isValueSelectedMCash) {
        this.QNAmcashValue = this.McashGifts[index].value
      } else {
        this.QNAmcashValue = 0
      }
    },
    updateSelectedGiftWallet(index, id) {
      this.QNAmcashValue = 0
      this.selectedIdMCash = ''
      if (this.selectedIdWallet === index) {
        this.isValueSelectedWallet = false
        this.selectedIdWallet = ''
      } else {
        this.isValueSelectedWallet = true
        this.selectedIdWallet = index
      }
      if (this.isValueSelectedWallet) {
        this.QNAwalletvalue = this.walletGifts[index].value
      } else {
        this.QNAwalletvalue = 0
      }
    },
    viewerProductModel() {
      $('#liveproduct-modelbox').modal('show')
      this.activePrdt = true
    },
    toggleChat() {
      this.isChatBox = true
      $('#Chat-modal').modal('show')
      $('#msg-chatbox').focus()
    },
    openQuestinareModal() {
      $('#quetionareModal').modal('show')
      document.getElementById('QNAinputBox').value = ''
      this.$http
        .get('https://be.payboard.in/PayBoard/rest/channels/getGifts')
        .then(
          function(data) {
            console.log('tag', data)
            this.McashGifts = data.body.MCASH
            this.freeGifts = data.body.GIFT
            this.walletGifts = data.body.WALLET
            console.log('tag', this.giftImage)
          },
          response => {}
        )
    },
    openModal() {
      $('#giftModal').modal('show')
      this.$http
        .get('https://be.payboard.in/PayBoard/rest/channels/getGifts')
        .then(
          function(data) {
            console.log('tagggggg', data)
            this.McashGifts = data.body.MCASH
            this.freeGifts = data.body.GIFT
            this.walletGifts = data.body.WALLET
            console.log('tag', this.giftImage)
          },
          response => {}
        )
    },
    closeModal() {
      $('#giftModal').modal('hide')
      $('#quetionareModal').modal('hide')
      $('#liveproduct-modelbox').modal('hide')
      $('#Chat-modal').modal('hide')
      this.isChatBox = false
      this.activePrdt = false
      this.showQuestionGift = false
    },
    sendGifts() {
      try {
        _AI.refereshToken = res => {
          console.log('==res==', res)
          try {
            if (res != 'fail') {
              const obj = {
                room_id: this.channel,
                gift_id: this.selectedId,
                x_auth_id: this.xAuthId,
                value_type:
                  this.selectedType === 'MCASH' ? 'MPOINT' : this.selectedType,
                value: this.selectedValue,
                broadcaster_name: this.firstName,
                x_auth_token: this.xAuthToken,
                jwt_token: res
              }
              console.log('==obj==', obj)
              const data = parsoDi(obj)
              this.$socket.emit('tip_as_a_gift', {
                data
              })
            } else {
              alert(this.$t('wentwrong'))
            }
          } catch (err) {
            console.log('==socket err==', err)
          }
        }
        JSBridgePlugin.refreshTokens('_AI.refereshToken')
      } catch (err) {
        // this.isLoading = false;
        console.log(err)
      }

      // this.$http
      //   .post(`${BASE_API_URL}/process_tip`, {
      //     data
      //   })
      //   .then(
      //     function(data) {
      //       console.log('------teenpatti---', data)
      //       if (data.body.success == true) {
      //         // alert('thank you for your appreciation')
      //         this.$toast.bottom(data.body.message)
      //         this.closeModal()
      //       } else if (data.body.success == false) {
      //         // alert('please try one more time')
      //         this.$toast.bottom(data.body.message)
      //       }
      //     },
      //     response => {}
      //   )
    },

    followUser() {
      let _this = this
      let headers = {
        'X-Auth-Id': this.xAuthId
      }
      var obj = {
        connectionXAuthId: this.roomOwnerXAuthID,
        source: 'GO_LIVE'
      }
      this.$http
        .post('https://be.payboard.in/PayBoard/rest/user/follow', obj, {
          headers
        })
        .then(
          function(data) {
            if (data.body.data.requestStatus === 'SUCCESS') {
              _this.isFollower = true
            } else {
              this.$toast.bottom(data.body.message)
            }
          },
          response => {
            this.$toast.bottom(this.$t('serverNotRespo'))
          }
        )
    },

    checkUserIsAdmin() {
      this.isAdminUser = adminXAuthIds.includes(this.xAuthId)
    },

    handleBlockUser() {
      var obj = {
        room_id: this.channel,
        ban_requested_by: this.xAuthId
      }
      this.$http
        .post('http://teenpatti.money91.com/remove_live_user', obj)
        .then(
          function(data) {
            if (data.body.success) {
              this.handleExit()
            } else {
              this.$toast.bottom(data.body.message)
            }
          },
          response => {}
        )
    },

    scrollToBottom() {
      setTimeout(function() {
        var a = $('#chatRoomList')
        a.animate({
          scrollTop: a[0].scrollHeight
        })
      }, 100)
    },

    addMessage() {
      if (this.textMessage !== '' && this.textMessage.trim().length > 0) {
        var textMessage = this.textMessage.toLowerCase()
        for (var _ in this.$data.abusive) {
          if (textMessage.indexOf(this.$data.abusive[_].toLowerCase()) > -1) {
            console.log(textMessage, this.$data.abusive[_].toLowerCase())
            alert(this.$t('accountMayBlock'))
            return
          }
        }
        this.$socket.emit(
          'text',
          {
            x_auth_id: this.xAuthId,
            room_id: this.channel,
            msg: this.textMessage
          },
          () => {
            this.scrollToBottom()
          }
        )
        this.textMessage = ''
      } else {
        this.$toast.bottom(this.$t('writeComment'))
      }
    },

    streamInit(uid, attendeeMode, videoProfile, config) {
      let defaultConfig = {
        streamID: uid,
        audio: true,
        video: true,
        screen: false
      }

      defaultConfig.video = false
      defaultConfig.audio = true

      let stream = AgoraRTC.createStream(merge(defaultConfig, config))
      stream.setVideoProfile(videoProfile)
      return stream
    },

    subscribeStreamEvents() {
      let rt = this
      rt.client.on('stream-added', function(evt) {
        // if(!rt.callerStream) {
        console.log('evtevt', evt)
        let stream = evt.stream
        console.log('New stream added: ' + stream.getId())
        console.log('At ' + new Date().toLocaleTimeString())
        console.log('Subscribe--', stream)
        rt.client.subscribe(stream, function(err) {
          console.log('Subscribe stream failed', err)
        })
        // rt.callerStream = true
        // } else {
        //   console.log('evtevt',evt)
        //   let stream = evt.stream
        //   rt.callerStreamData = stream
        // }
      })

      rt.client.on('peer-leave', function(evt) {
        console.log('Peer has left: ' + evt.uid)
        console.log(new Date().toLocaleTimeString())
        console.log(evt)
        rt.removeStream(evt.uid)
      })

      rt.client.on('stream-removed', function(evt) {
        let stream = evt.stream
        console.log('Stream removed: ' + stream.getId())
        console.log(new Date().toLocaleTimeString())
        console.log(evt)
        rt.removeStream(stream.getId())
      })

      rt.client.on('client-role-changed', function(evt) {
        console.log('client-role-changedd', evt.role)
        console.log('client-role-changedd', evt)
      })

      rt.client.on('stream-subscribed', function(evt) {
        let stream = evt.stream
        console.log('Got stream-subscribed event')
        console.log(new Date().toLocaleTimeString())
        console.log('Subscribe remote stream successfully: ' + stream.getId())
        console.log(evt)
        // rt.remoteStream = stream
        rt.addStream(stream)
      })
    },
    removeStream(uid) {
      this.streamList.map((item, index) => {
        if (item.getId() === uid) {
          item.close()
          let element = document.querySelector('#ag-item-' + uid)
          if (element) {
            element.parentNode.removeChild(element)
          }
          let tempList = [...this.streamList]
          tempList.splice(index, 1)
          this.streamList = tempList
        }
      })
    },

    addStream(stream, push = false) {
      let repeatition = this.streamList.some(item => {
        return item.getId() === stream.getId()
      })
      if (repeatition) {
        return
      }
      if (push) {
        this.streamList = this.streamList.concat([stream])
      } else {
        this.streamList = [stream].concat(this.streamList)
      }
    },

    handleExit(e) {
      // this.$store.commit('updateSelected', {
      //   selected: this.$store.getters.selected
      // })
      // this.changeRoleAgain('disconnect')

      if (this.initiatedCallXauthId == this.xAuthId) {
        this.changeRoleAgain()
      }
      try {
        window.clearInterval(this.interval)
      } catch (err) {
        console.log('---', err)
      }
      this.$cookie.set('isRedirecting', '')
      this.$socket.emit(
        'leave_live_show',
        { xAuthId: this.xAuthId, room_id: this.channel },
        () => {
          console.log('leave_live_show')
        }
      )

      try {
        this.client && this.client.unpublish(this.localStream)
        this.localStream && this.localStream.close()
        this.client &&
          this.client.leave(
            () => {
              console.log('Client succeed to leave.')
            },
            () => {
              console.log('Client failed to leave.')
            }
          )
      } finally {
        this.readyState = false
        this.client = null
        this.localStream = null
        if (this.$route.query.src === 'feed') {
          JSBridgePlugin.gotToHome()
        } else {
          this.$router.go(-1)
        }
      }
    },

    openPromotedURl() {
      window.location.href = this.promotedUrl + this.xAuthId
    },

    declineCalling() {
      this.callingCash = 1
      this.viewCalloverlayCalling = 'none'
      this.changeRoleAgain()
    },

    notCalling() {
      this.viewCalloverlay = 'none'
    },

    confirmCalling() {
      console.log('===---')
      // this.viewCalloverlayCalling = 'block'
      if (this.callingCash > 0) {
        // this.viewCalloverlay = 'none'
        // this.changeRole()
        let naeHo = {
          x_auth_id: this.xAuthId,
          room_id: this.channel,
          mobile_no: this.roomOwnerMobileNo,
          mcash: this.callingCash
        }
        let cipher_text = parsoDi(naeHo)
        console.log('==---==cipher_text==--', cipher_text)
        this.$socket.emit('initiate_call', {
          cipher_text: cipher_text
        })
      } else {
        this.$toast.bottom(this.$t('IncreaseMPoint'))
      }
    },

    callToBroadcaster() {
      this.viewCalloverlay = 'block'
    },

    autoHeartEmitting() {
      this.interval = setInterval(() => {
        let newcount = ++this.count
        var r = Math.round(Math.random() * 6)
        var c = Math.round(Math.random() * 4)
        var img = require(`../assets/images/${this.bubbleColors[c]}_heart.png`)
        var ComponentClass = Vue.extend(LoveComponent)
        var instance = new ComponentClass({
          propsData: {
            type: `fa fa-heart ${this.bubbleImages[r]}`,
            src: img,
            id: `faID${newcount}`
          }
        })
        instance.$mount()
        document.getElementById('heartRef').appendChild(instance.$el)
        setTimeout(function() {
          if (document.getElementById(`faID${newcount}`) !== null)
            document.getElementById(`faID${newcount}`).remove()
        }, 3000)
      }, 300)
    },

    changeRole() {
      let _this = this
      // Sets the client role to “host” or “audience”.
      _this.client.setClientRole(
        'host',
        function() {
          // _this.addStream(_this.localStream, true);
          _this.client.publish(_this.localStream, err => {
            console.log('Publish local stream error: ' + err)
          })
        },
        function(e) {
          console.log('setHost failed', e)
        }
      )
    },

    changeRoleAgain() {
      console.log('this.callStates', this.callStates)
      if (this.callStates == 'decline') {
        let naeHo = {
          room_id: this.channel,
          mcash: this.callingCash
        }
        let cipher_text = parsoDi(naeHo)
        this.$socket.emit('decline_call', {
          cipher_text
        })
      } else {
        let naeHo = {
          room_id: this.channel
        }
        let cipher_text = parsoDi(naeHo)
        this.$socket.emit(
          'disconnect_call',
          {
            cipher_text
          },
          () => {
            console.log('disconnect_call')
            let _this = this
            _this.client.setClientRole(
              'audience',
              function() {
                console.log('setHost success audience')
                // _this.audioCallBtn = true
                // _this.showDisconnectCall = false
              },
              function(e) {
                console.log('setHost failed', e)
              }
            )
          }
        )
      }
    }
  },

  sockets: {
    tip_response: function(data) {
      this.closeModal()
      console.log('=---===data=---=', data)
    },
    call_decline: function(data) {
      this.showDisconnectCall = false
      this.callingCash = 1
      this.audioCallBtn = true
      this.showDnd = false
      this.viewCalloverlayCalling = 'none'
      this.initiatedCallXauthId = null
      this.showBusy = false
    },

    remove_call_buttton: function(data) {
      this.audioCallBtn = false
    },

    call_received: function(data) {
      let dataDecrypted = aajDi(data)
      this.showDnd = false
      this.viewCalloverlayCalling = 'none'
      if (dataDecrypted.viewer_x_auth_id == this.xAuthId) {
        this.callStates = 'disconnect'
        this.changeRole()
        this.showDisconnectCall = true
        this.audioCallBtn = false
        this.showBusy = false
      } else {
        this.showDisconnectCall = false
        this.showBusy = true
      }
      // if (data.viewer_x_auth_id == this.xAuthId) {
      //   this.showDisconnectCall = true
      //   this.showBusy = false
      // }else{
      //   this.showBusy = true
      // }
    },

    call_disconnected: function(data) {
      console.log('===call_disconnected=fire', data)
      if (this.initiatedCallXauthId == this.xAuthId) {
        this.$toast.bottom(data.message)
      }
      this.showDisconnectCall = false
      this.audioCallBtn = true
      this.showBusy = false
      this.showDnd = false
      this.callingCash = 1
      this.initiatedCallXauthId = null
      this.changeRoleAgain()
    },

    call_initiated: function(data) {
      console.log('==call_initiated===', data)
      let dataDecrypted = aajDi(data)
      this.viewCalloverlay = 'none'
      this.audioCallBtn = false
      this.callingCash = dataDecrypted.mcash || 1
      this.initiatedCallXauthId = dataDecrypted.viewer_x_auth_id
      if (dataDecrypted.viewer_x_auth_id == this.xAuthId) {
        this.callStates = 'decline'
        this.showDisconnectCall = true
        this.showBusy = false
        this.viewCalloverlayCalling = 'block'
      } else {
        this.showDisconnectCall = false
        this.showBusy = true
      }
    },
    remove_call_option: function(data) {
      console.log('=remove_call_option===', data)
      this.viewCalloverlayCalling = 'none'
      this.audioCallBtn = true
      this.showDisconnectCall = false
    },
    call: function(data) {
      console.log('==call call==', data)
      if (data.call_status == 3) {
        this.showDnd = true
        this.audioCallBtn = false
        this.showBusy = false
      }
      this.viewCalloverlay = 'none'
      this.$toast.bottom(data.message)
    },

    // error: function(data) {
    //   console.log('error---', data)
    //   this.$toast.bottom(data.message)
    // },

    dnd: function(data) {
      console.log('===dnd===', data)
      if (data.dnd) {
        this.audioCallBtn = false
        this.showDnd = true
        this.showBusy = false
      } else {
        this.audioCallBtn = true
        this.showDnd = false
        this.showBusy = false
      }
    },
    //check user already kicked out
    blocking_user_from_watching_live_user: function(data) {
      if (data.is_kicked_out) {
        this.$toast.top(this.$t('broadcastKicked'))
        if (this.$route.query.src === 'feed') {
          JSBridgePlugin.gotToHome()
        } else {
          this.$router.go(-1)
        }
      }
    },
    changed_category: function(data) {
      console.log('-----data---', data)
      this.$store.commit('updateSelected', {
        selected: data.category
      })
    },
    new_live_product: function(data) {
      console.log('==----=new_live_product--==-viewer--', data)
      this.viewerProductImage = data.data ? data.data.itemImage : null
      this.viewerProductList = data.data ? data.data : null
    },
    broadcaster_ordered_data: function(data) {
      this.viewerProductImage = data.data ? data.data.itemImage : null
      this.viewerProductList = data.data ? data.data : null
    },
    // kick_out_user_from_room
    kick_out_response: function(data) {
      if (data.x_auth_id === this.xAuthId) {
        this.handleExit()
        this.$socket.emit('all_live_user')
        // this.$socket.emit('categories_wise_live_user', {
        //   category: this.$store.getters.selected
        // })
      }
    },
    purse_status: function(data) {
      this.$toast.bottom(this.$t('submitedques'))
    },
    qna_t_response: function(data) {
      this.$toast.bottom(this.$t('Nobalance'))
    },
    user_new_question: function(data) {
      this.viewerQNAquestionlist.push(data.data)
    },
    special_effect_response: function(data) {
      this.viewer_side_heart_render(data.color)
    },
    new_comment: function(data) {
      console.log('--data-', data)
      this.allMessages.push(data)
      this.scrollToBottom()
    },
    follow: function(data) {
      this.isFollower = data.is_follower
    },
    previous_comments: function({ data }) {
      if (data.room_id === this.channel) {
        this.allMessages.push(data.all_comments)
        this.scrollToBottom()
      }
    },

    leave_room: function(data) {
      this.$toast.bottom(data.msg)
    },

    broadcaster_details: function(data) {
      if (data.is_communicating == 0 && data.dnd == false) {
        this.audioCallBtn = true
        this.showDnd = false
        this.showBusy = false
      }
      if (data.is_communicating === 3) {
        this.showDnd = true
        this.showBusy = false
        this.audioCallBtn = false
      }

      if (data.is_communicating === 2 || data.is_communicating === 1) {
        this.showBusy = true
        this.showDnd = false
        this.audioCallBtn = false
      }

      if (!data.active) {
        this.$toast.top(this.$t('liveEnded'))
        if (this.$route.query.src === 'feed') {
          JSBridgePlugin.gotToHome()
        } else {
          this.$router.go(-1)
        }
      }
      this.$store.commit('updateSelected', {
        selected: data.category
      })
      this.firstName = data.first_name
      this.lastName = data.last_name
      this.userImage = data.image_url
      this.userLocation = data.location
      this.roomOwnerXAuthID = data.x_auth_id
      this.roomOwnerMobileNo = data.mobile_no
      this.contentID = data.content_id
      if (data.url !== null) {
        this.promotedUrl = data.url
        this.promotedUser = true
      }
    },

    live_connected_user_count: function(data) {
      if (data.room_id === this.channel) {
        this.liveUserCount = data.live_user_count
      }
      if (data.room_id === 'mall91videochannel') {
        this.promotedUserLive = true
      } else {
        this.promotedUserLive = false
      }
    },

    broadcast_live_connected_user_count: function(data) {
      if (data.room_id == this.channel) {
        this.liveUserCount = data.live_user_count
      }
      if (data.room_id === 'mall91videochannel') {
        this.promotedUserLive = true
      } else {
        this.promotedUserLive = false
      }
    },

    stop_live_streaming: function(data) {
      this.$toast.bottom(data.msg)
      this.$cookie.set('isRedirecting', '')
      this.$store.commit('updateSelected', {
        selected: ''
      })
      if (this.$route.query.src === 'feed') {
        JSBridgePlugin.gotToHome()
      } else {
        this.$router.go(-1)
      }
    },

    disconnection: function(data) {
      this.$toast.bottom(data.msg)
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    user_disconnected: function(data) {
      this.$toast.bottom(data.msg)
    }
  },

  mounted() {
    this.loadViwerStreaming()
    __native_money91._onPause = function() {
      _this.$router.go(-1)
    }
    this.autoHeartEmitting()
    this.changeLocale()
    this.checkUserIsAdmin()
    if (this.$route.query.src === 'feed') {
      this.$socket.emit('watch_user_live', {
        xAuthId: Cookies.get('X-Auth-Id'),
        room_id: this.channel
      })
    }
    var timeRemaining = this.handleDateCounter()
    console.log('===timeRemaining=', timeRemaining)
    if (timeRemaining.off) {
      window._intervalTimerToogle = false
    }
    //   var a = Cookies.get('isRedirecting')
    // console.log('--==----==---=this.$cookie.get()-==-isRedirecting===----',a)

    if (this.$cookie.get('isRedirecting') === 'true') {
      this.$store.commit('updateSelected', {
        selected: 'shopping'
      })
      this.$socket.emit('watch_user_live', {
        xAuthId: Cookies.get('X-Auth-Id'),
        room_id: this.channel
      })
    }

    let headers = {
      'X-Auth-Id': this.xAuthId,
      'X-Auth-Token': 'da85e2fb-295d-43d4-b7a6-85a5d3c235f9'
    }
    this.$http
      .get(
        'https://be.payboard.in/PayBoard/rest/content/getContentReportingReasons',
        {
          headers
        }
      )
      .then(function(data) {
        this.contentReportList = data.body
      })
  },

  beforeUpdate() {
    initAgora(this.streamList, this.displayMode)
  },

  beforeDestroy() {
    if (this.initiatedCallXauthId == this.xAuthId) {
      this.changeRoleAgain()
    }

    try {
      window.clearInterval(this.interval)
    } catch (err) {
      console.log('---', err)
    }

    this.$socket.emit('leave_live_show', {
      xAuthId: this.xAuthId,
      room_id: this.channel
    })
    this.client && this.client.unpublish(this.localStream)
    this.localStream && this.localStream.close()
    this.client &&
      this.client.leave(
        () => {
          document.querySelector('body').classList.remove('modal-open')
          $('.modal-backdrop').css('display', 'none')
          console.log('Client succeed to leave.')
        },
        () => {
          console.log('Client failed to leave.')
        }
      )
  }
}
</script>

<style scoped>
.cancelp {
  height: 32px;
  background: #ff0f00;
  border-radius: 50%;
  padding: 8px;
  transform: translate(-50%, -50%) rotate(225deg);
  top: 16px;
  position: absolute;
  right: 32px;
}
</style>
